import * as React from "react";
import { useIntl } from "@grandvisionhq/state";
import { useOnExpand } from "../../../../hooks/hooks/use-on-expand.js";
import { OPENING_HOURS_DAYS } from "../../../../types/types/index.js";
import OpeningHours from "./OpeningHours.js";
import { deprecatedPropsToProps } from "./utils.js";
const isToday = (day) => (OPENING_HOURS_DAYS[(/* @__PURE__ */ new Date()).getDay()] ?? "") === day;
const getDayName = (date) => OPENING_HOURS_DAYS[date.getDay()];
const hasDeprecatedProps = (props) => "schedule" in props;
const OpeningHoursContainer = (props) => {
  const {
    openingHours,
    specialOpeningHours = [],
    isExpanded: initialIsExpanded = false,
    isExpandable = true,
    onExpandCallback,
    announcement,
    ...rest
  } = hasDeprecatedProps(props) ? deprecatedPropsToProps(props) : props;
  const { isExpanded, onExpand } = useOnExpand({ initialIsExpanded, onExpandCallback });
  const {
    getLabel,
    dateTime: { formatMidsizeDate }
  } = useIntl();
  const labels = React.useMemo(
    () => ({
      title: getLabel("locations.openingHours.title"),
      specialTitle: getLabel("locations.openingHours.specialTitle"),
      regularTitle: getLabel("locations.openingHours.regularTitle")
    }),
    [getLabel]
  );
  const regular = React.useMemo(
    () => Object.entries(openingHours).map(([day, items]) => {
      const isOpen = items.length > 0;
      const entries = isOpen ? items.map(({ open, close }) => ({
        key: `${day}-${open}-${close}`,
        value: `${open} - ${close}`
      })) : [{ key: `${day}-closed`, value: getLabel("locations.openingHours.closed") }];
      return {
        label: getLabel(`locations.openingHours.days.long.${day}`),
        today: isToday(day),
        status: isOpen ? "OPEN" : "CLOSED",
        entries
      };
    }),
    [openingHours, getLabel]
  );
  const special = React.useMemo(
    () => (specialOpeningHours ?? []).map(
      ({ openClosed, dateOpenClosed, openClosedTime }) => {
        const date = new Date(dateOpenClosed);
        const isOpen = openClosed === "OPEN";
        const entries = isOpen ? (openClosedTime ?? []).map(({ open, close }) => ({
          key: `${dateOpenClosed}-${open}-${close}`,
          value: `${open} - ${close}`
        })) : [
          {
            key: `${dateOpenClosed}-closed`,
            value: getLabel("locations.openingHours.closed")
          }
        ];
        return {
          label: `${getLabel(
            `locations.openingHours.days.short.${getDayName(date)}`
          )}, ${formatMidsizeDate(date)}`,
          status: openClosed,
          entries
        };
      }
    ),
    [specialOpeningHours, formatMidsizeDate, getLabel]
  );
  return /* @__PURE__ */ React.createElement(
    OpeningHours,
    {
      ...rest,
      announcement,
      labels,
      regular,
      special,
      openingHours,
      specialOpeningHours,
      isExpanded,
      onExpand: isExpandable ? onExpand : void 0
    }
  );
};
export {
  OpeningHoursContainer as default
};
//# sourceMappingURL=OpeningHoursContainer.js.map
